
import { HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Observable, from } from "rxjs";
import { RaskModalService } from "../components/modal/rask-modal.service";
import { IContent } from "../models/validationModel";
import { ObjectUtils } from "../utils/object-utils";

export type ErrorMessageType = "UserMessage" | "Unhandled" | "ValidationMessage" | "ClientValidationMessage" | "Message";
@Injectable({
    providedIn: "root"
})
export class ErrorMediatorService {
    handle: NgbModalRef;
    messages: IMessageWrapper[] = [];

    private readonly modalService = inject(RaskModalService);
    private readonly $translate = inject(TranslateService);

    add(content: IContent, request?: HttpRequest<any>): Observable<any> {
        this.messages.push({
            content: content,
            metadata: request
        });
        if (ObjectUtils.isNullOrUndefined(this.handle)) {
            const backdrop = "static";
            this.handle = this.modalService.errorsWithHandle(this.parseHeader(content.messageType), this.messages.map(x => x.content), backdrop);
            this.handle.componentInstance.copyFn = () => this.copyContentsToClipboard();
            this.handle.closed.subscribe(_ => this.finalize("closed"));
            this.handle.dismissed.subscribe(_ => this.finalize("dismissed"));
        } else {
            this.handle.componentInstance.messages = this.messages.map(x => x.content);
        }
        return from(this.handle.result);
    }

    finalize(action: string): void {
        this.messages.splice(0);
        this.handle = null;
    }

    copyContentsToClipboard(): void {
        const messages = this.messages.map(m => this.forClipboard(m)).join("\r\n------------------------------\r\n\r\n");
        ObjectUtils.copyToClipboard(messages);
    }

    private forClipboard(message: IMessageWrapper) {
        return `Route:       ${document.URL}\r\n` +
            `Timestamp:   ${new Date()}\r\n`+
            `UniqueId:    ${message.content.uniqueId ?? ""}\r\n` +
            `MessageType: ${message.content.messageType}\r\n` +
            `Message:     ${message.content.message}\r\n` +
            `Url:         ${message.metadata.urlWithParams}\r\n`;
    }

    private parseHeader(messageType?: ErrorMessageType) {
        if (messageType != null) {
            switch (messageType) {
                case "UserMessage":
                case "Unhandled":
                    return this.$translate.instant("ERROR_HEADER");
                case "ValidationMessage":
                case "ClientValidationMessage":
                    return this.$translate.instant("VALIDATION_HEADER");
                case "Message":
                    return this.$translate.instant("VALIDATION_MESSAGE");
                default:
                    return this.$translate.instant("VALIDATION_MESSAGE");
            }
        }
        return this.$translate.instant("ERROR_HEADER");
    }
}

export interface IMessageWrapper {
    content: IContent;
    metadata: any;
}
